export const flightReservationShow: any = {
  flightSummary: "フライトの概要",
  travelerInfo: "搭乗者情報",
  flightDetails: "フライト詳細",
  priceSummary: "料金の概要",
  regulation: "規則と制限事項",
  help: "ヘルプ",
};
